import { Outlet } from 'react-router-dom';
import './Layout.scss';
import React from 'react';
import vtechLogo from './assets/vtech.svg';
import leapfrogLogo from './assets/lf.svg';

function Layout() {
  return (
    <>
      <header
        style={{ backgroundImage: `url(${require('./assets/header.png')})` }}
      >
        <img src={leapfrogLogo} alt="LeapFrog" className="leapfrog" />
        <img src={vtechLogo} alt="vTech" className="vtech" />
        <svg
          className="wave"
          viewBox="0 0 1280 325"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 0H1280V285C1280 285 1005 374 640 285C275 196 0 285 0 285V0Z"
            fill="#fff"
          />
        </svg>
      </header>
      <main>
        <Outlet />
      </main>
      <footer>
        <a
          href="https://www.leapfrog.com/en-us/legal/privacy"
          className="privacy-link"
        >
          Privacy Policy
        </a>
        <div className="copyright">
          Copyright © 2001 - 2025 LeapFrog Enterprises, Inc. All rights
          reserved.
        </div>
      </footer>
    </>
  );
}

export default Layout;
